import React from 'react'

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">سمیه ارباب مجنی</h1>
            <p className="hero-subtitle">ریاضی با من برات یه تجربه شیرین و موندگار میشه</p>
            <p className="hero-description">
              با بیش از دو دهه تجربه در آموزش ریاضی در مقاطع ابتدایی ، دبیرستان ، دانشگاه.
            </p>
            <div className="hero-buttons">
              <a href="#about" className="btn btn-primary">درباره من</a>
              <a href="#contact" className="btn btn-secondary">تماس با من</a>
            </div>
          </div>
          <div className="hero-image">
            <div className="profile-placeholder">
              <img 
                src="/images/teacher1.webp" 
                alt="سمیه ارباب مجنی - مدرس ریاضی" 
                className="profile-image" 
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero 